// PathnameProvider.js

import Cookies from "js-cookie";
import React, { createContext, useContext, useEffect, useState } from "react";
import { useAuthContext } from "../hooks/useAuthContext";
import {
  collection,
  doc,
  onSnapshot,
  orderBy,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { projectFirestore } from "../firebase/config";
import impresoraManager from "../components/ImpresoraManager";

const PathnameContext = createContext();

const PathnameProvider = ({ children }) => {
  const { register } = useAuthContext();
  const [impresi, setImpresi] = useState(Cookies.get("impAut") === "true");
  const [docum, setDocum] = useState();
  const [conect, setConect] = useState(false);
  const [impresoraID, setImpresoraID] = useState();

  useEffect(() => {
    if (docum && impresi) {
      let fech = new Date();
      docum.forEach(async (data) => {
        let detalleImp = {};
        let newDatup = data?.detalle?.map((element) => {
          if (!element?.impresion) {
            if (
              element.recoger &&
              element.selectedDate === fech.toISOString().split("T")[0]
            ) {
              if (element?.selectedTime && detalleImp[element.selectedTime]) {
                detalleImp[element.selectedTime].push(element);
              } else if (element?.selectedTime) {
                detalleImp[element.selectedTime] = [element];
              } else if (detalleImp[element.selectedDate]) {
                detalleImp[element.selectedDate].push(element);
              } else {
                detalleImp[element.selectedDate] = [element];
              }
              return { ...element, impresion: true };
            } else if (!element.recoger) {
              let fech = new Date(data.fecha.seconds * 1000);
              let dateord = fech.toISOString().split("T")[0];
              if (dateord === fech.toISOString().split("T")[0]) {
                if (detalleImp[dateord]) {
                  detalleImp[dateord].push(element);
                } else {
                  detalleImp[dateord] = [element];
                }
              }
              return { ...element, impresion: true };
            } else return element;
          } else return element;
        });
        if (Object.keys(detalleImp).length > 0) {
          await Object.keys(detalleImp).forEach(async (key) => {
            let dataCopy;
            if (key.includes(":")) {
              let spl = key.split(":");
              let dat = new Date();
              dat.setHours(parseInt(spl[0]), parseInt(spl[1]), 0, 0);
              dataCopy = {
                ...data,
                detalle: detalleImp[key],
                fecha: { seconds: dat.getTime() / 1000 },
              };
            } else {
              dataCopy = { ...data, detalle: detalleImp[key] };
            }
            await impresoraManager
              .imprimir(dataCopy, register, "Administrador", true)
              .then(async (e) => {
                await updateDoc(doc(projectFirestore, "turnero", data.id), {
                  detalle: newDatup,
                });
              })
              .catch((error) => {
                alert(error);
              });
          });
        }
      });
    }
  }, [impresi, docum, register]);

  useEffect(() => {
    if (register) {
      let fechaact = new Date();
      fechaact.setDate(fechaact.getDate() - 7);
      const filtros = [
        { campo: "puesto", operador: "==", valor: register.id },
        { campo: "fecha", operador: ">=", valor: fechaact },
        { campo: "status", operador: "==", valor: "ATENDIDO" },
      ];
      let q = query(collection(projectFirestore, "turnero"));
      filtros.forEach((filtro) => {
        const { campo, operador, valor } = filtro;
        q = query(q, where(campo, operador, valor));
      });
      q = query(q, orderBy("fecha", "desc"));
      let escucha = onSnapshot(q, (docs) => {
        const documentosColeccion = [];
        docs.docs.forEach((docu) => {
          const data = docu.data();
          data.id = docu.id;
          documentosColeccion.push(data);
        });
        setDocum(documentosColeccion);
      });
      return escucha;
    }
  }, [register]);

  return (
    <PathnameContext.Provider
      value={{
        impresi,
        setImpresi,
        conect,
        setConect,
        impresoraID,
        setImpresoraID,
      }}
    >
      {children}
    </PathnameContext.Provider>
  );
};

const usePathname = () => useContext(PathnameContext);

export { PathnameProvider as default, usePathname };
